export const getGroupsFrag = `
    id
    name
`;
